import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function OverwriteConfirm({ pending, onKeep, onReplace, onCancel }) {
  const list = pending?.overwrites || [];
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="import-overwrite-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Replace {list.length} note{list.length === 1 ? "" : "s"} on this device?</AlertDialogTitle>
          <AlertDialogDescription>The backup has newer copies of: {list.slice(0, 5).join(", ")}{list.length > 5 ? ` and ${list.length - 5} more` : ""}. Sealed versions are always kept either way.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="import-overwrite-cancel">Cancel import</AlertDialogCancel>
          <Button variant="outline" onClick={onKeep} data-testid="import-keep-mine">Keep mine, add new only</Button>
          <AlertDialogAction onClick={onReplace} data-testid="import-replace">Replace with backup</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
